import './Bar.css';

import ButtonVariableManager from './ButtonVariableManager/ButtonVariableManager';
import ButtonFullScreen from './ButtonFullScreen/ButtonFullScreen';
import ZoneBlockCreation from './ZoneBlockCreation/ZoneBlockCreation';
import ButtonCenterView from './ButtonCenterView/ButtonCenterView';
import SearchBar from './SearchBar/SearchBar';
import ButtonImportTemplate from './ButtonImportTemplate/ButtonImportTemplate';
import ButtonDebug from './ButtonDebug/ButtonDebug';
import ButtonSelection from './ButtonSelection/ButtonSelection';
import ButtonRunChatbox from './ButtonRunChatbox/ButtonRunChatbox';
import ButtonTelephony from './ButtonTelephony/ButtonTelephony';
import ButtonAiChat from '../../teia/ButtonAiChat/ButtonAiChat';
import { useState, useEffect } from 'react';
import isInputSelected from '/src/utils/isInputSelected';
import canUseTeia from '../../utils/canUseTeia';
// Simple component to handle all the custom action in the bot editor
function Bar() {

    const [creatingBlock, setCreatingBlock] = useState(false);
    const [positionMouse, setPositionMouse] = useState(null);
    const handleKeyDown = (e) => {

        let elements = Array.from(document.querySelectorAll(":hover"));
        let isInCamera = elements.some(element => element.classList.contains("camera"));
        var canOperate = (creatingBlock === false && isInCamera === true) || (creatingBlock === true && isInCamera === false);

        if (e.key === ' ' && canOperate && isInputSelected() == false ) {
            setCreatingBlock((previousState) => !previousState);
            e.preventDefault();
        }
    }
    const handleMousePosition = (e) => {
        if (creatingBlock == true) return;
        const mouseX = e.clientX;
        const mouseY = e.clientY;
        setPositionMouse({ left: mouseX - 50 + "px", top: mouseY + "px" });
    };
    useEffect(() => {
        document.addEventListener('mousemove', handleMousePosition);

        return () => {
            document.removeEventListener('mousemove', handleMousePosition);
        };
    }, [creatingBlock]);

    useEffect(() => {
        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [creatingBlock]);

    return (
        <div className="editor-bar" >
            <ZoneBlockCreation showing={creatingBlock} position={positionMouse} setShowing={(bool) => setCreatingBlock(bool)} />
            <ButtonVariableManager />
            <ButtonCenterView />
            <ButtonFullScreen />
            <ButtonImportTemplate />
            <SearchBar />
            <ButtonSelection />
            <ButtonDebug />
            <ButtonRunChatbox />
            <ButtonTelephony />
            {canUseTeia() && <ButtonAiChat />}
        </div>
    )
}

export default Bar;